import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';

import { jsxActions as scannedToolPageActions }  from '../../../actions/Mobile/ScannedToolPage/scannedToolPageActions.js';
import { jsxActions as headerActions }  from '../../../actions/Mobile/Header/headerActions.js';

import ScannedToolPage from '../../../components/Mobile/ScannedToolPage/scannedToolPage.js';


function mapDispatchToProps(dispatch) {
  return {
    actions: {
      ...bindActionCreators(scannedToolPageActions, dispatch),
      header: bindActionCreators(headerActions, dispatch),
    }
  }
}

let ScannedToolPageContainer = connect(
  (state) => {
    return {
      sData: state.mobile.get('data'),
      sPageData: state.mobile.get('scannedToolPage'),

    };
  },
  mapDispatchToProps
)(ScannedToolPage);

export default ScannedToolPageContainer;




